import clsx from 'clsx';
import React, { FC } from 'react';

import classes from './classes.module.css';

interface OptionProps {
  value: number;
  isSelected: boolean;
  onClick: () => void;
}

const Option: FC<OptionProps> = ({ value, isSelected, onClick }) => {
  return (
    <div
      className={clsx(classes.container, isSelected && classes.selected)}
      onClick={onClick}
    >
      {value}
    </div>
  );
};

export default Option;
